import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    /* Colori monocromatici (bianco, nero, grigio) */
    --bg-primary: #0A0A0A;
    --bg-secondary: #121212;
    --text-primary: #F5F5F5;
    --text-secondary: #A0A0A0;
    --accent-primary: #D0D0D0;    /* Grigio chiaro invece di #E91E63 (rosa) */
    --accent-secondary: #EFEFEF;  /* Grigio ancora più chiaro invece di #FF007A (fucsia) */
    --card-overlay: rgba(10, 10, 10, 0.7);
    --border-color: #555555;
    
    /* Colori per la scrollbar */
    --scrollbar-track: #0A0A0A;
    --scrollbar-thumb: #555555;
    --scrollbar-thumb-hover: #777777;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  /* Scrollbar personalizzata */
  ::-webkit-scrollbar {
    width: 8px;
    background-color: var(--scrollbar-track);
  }

  ::-webkit-scrollbar-thumb {
    background-color: var(--scrollbar-thumb);
    border-radius: 10px;
    border: 2px solid var(--scrollbar-track);
    transition: background-color 0.3s ease;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: var(--scrollbar-thumb-hover);
    border: 1.5px solid var(--scrollbar-track);
  }

  /* Stile per Firefox */
  * {
    scrollbar-width: thin;
    scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
  }

  body {
    font-family: 'Inter', sans-serif;
    background-color: var(--bg-primary);
    color: var(--text-primary);
    overflow-x: hidden;
    font-weight: 300;
    letter-spacing: 0.02em;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Playfair Display', serif;
    margin-bottom: 1rem;
    font-weight: 500;
    letter-spacing: 0.01em;
  }

  h1 {
    font-size: 3.5rem;
    line-height: 1.2;
  }

  h2 {
    font-size: 2.8rem;
    line-height: 1.3;
  }

  h3 {
    font-size: 2.2rem;
  }

  p {
    line-height: 1.6;
    margin-bottom: 1rem;
  }

  a {
    color: var(--accent-primary);
    text-decoration: none;
    transition: color 0.3s ease;
    
    &:hover {
      color: var(--accent-secondary);
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }

  button {
    cursor: pointer;
    font-family: 'Inter', sans-serif;
    transition: all 0.3s ease;
    font-weight: 400;
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
  }

  .section {
    padding: 5rem 0;
  }

  .text-center {
    text-align: center;
  }

  /* Animazioni base per elementi */
  .fade-in {
    opacity: 0;
    animation: fadeIn 1s forwards;
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

export default GlobalStyles; 
